import React, { useState } from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { useStyles } from '../../../pages/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from 'react-i18next';
import TooltipOneComponent from '../../TooltipOne/TooltipOne.component';
import { useTabNavigationDetails } from '../../../Context/TabNavigation.context';

interface SelectAllMenuProps {
  allMode: boolean;
  tabIndex?: number;
  onAllOnPageClick: () => void;
  onAllClick: () => void;
}

export const SelectAllMenu: React.FC<SelectAllMenuProps> = ({ allMode, onAllOnPageClick, onAllClick, tabIndex }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { isDuringAction, activeRowIndex } = useTabNavigationDetails();

  const [anchorElCheckboxFilter, setAnchorElCheckboxFilter] = useState<HTMLButtonElement | null>(null);
  const handleClickCheckboxFilter = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorElCheckboxFilter(event.currentTarget);
  };

  const handleCloseCheckboxFilter = () => {
    setAnchorElCheckboxFilter(null);
  };

  const focusIfActive = (input: SVGSVGElement | null) => {
    if (isDuringAction && activeRowIndex === -2) {
      input && input.focus();
    }
    return input;
  };

  return (
    <span>
      <IconButton
        disableRipple
        aria-label="Ikonka rozwijająca menu trybu zaznaczania wierszy"
        size="small"
        onClick={handleClickCheckboxFilter}
        tabIndex={-1}
        onKeyDown={(event: React.KeyboardEvent<HTMLButtonElement>) => {
          if (event.key === 'Enter') {
            setAnchorElCheckboxFilter(event.currentTarget);
          }
        }}
        aria-expanded={anchorElCheckboxFilter !== null}
      >
        <TooltipOneComponent title="Opcje zaznaczania" placement="top">
          <ArrowDropDownIcon
            style={{ marginLeft: -10, top: 6 }}
            className={classes.ArrowDropDownIcon}
            aria-controls={anchorElCheckboxFilter ? 'checkbox-menu' : undefined}
            aria-haspopup="true"
            tabIndex={tabIndex}
            ref={(input) => focusIfActive(input)}
          />
        </TooltipOneComponent>
      </IconButton>
      <Menu
        className={classes.checkboxList}
        id="checkbox-menu"
        anchorEl={anchorElCheckboxFilter}
        keepMounted
        open={Boolean(anchorElCheckboxFilter)}
        onClose={handleCloseCheckboxFilter}
      >
        <MenuItem
          disableRipple
          selected={!allMode}
          onClick={() => {
            handleCloseCheckboxFilter();
            onAllOnPageClick();
          }}
        >
          Wszyscy na stronie
        </MenuItem>
        <MenuItem
          disableRipple
          data-testid="every"
          selected={allMode}
          onClick={() => {
            handleCloseCheckboxFilter();
            onAllClick();
          }}
        >
          Wszyscy
        </MenuItem>
      </Menu>
    </span>
  );
};
